import OwsOptionsCollection from './OwsOptionsCollection';

export enum LoadState {
    OptionsNotLoaded,
    OptionsLoading,
    OptionsLoaded,
}

interface OwsOptionsStore {
    options: OwsOptionsCollection;
    loadState: LoadState;
}

export default OwsOptionsStore;
